<h1 mat-dialog-title  class="title-dialog">ETA follow up reminder {{ data.fd_number}}</h1>
<div mat-dialog-content>
  <p>Take action and follow up on {{ data.fd_number }} as soon as possible.</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>OK</button>
</div>
